export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "f984c13e-a987-44cd-84ec-b69b799477f2";
export const MODAL_CLOSE_SEC = 2.5;
